import { useCallback } from 'react';
import { useUIStore } from '../store/uiStore';

/**
 * Returns a matched pair of callbacks for BottomSheetModal sheets: call
 * `hold()` when presenting the sheet and `release()` when it dismisses.
 * The pair is ref-counted via uiStore so nested sheets balance correctly.
 *
 * Intended for raw-gorhom BottomSheetModal sheets (post-create internals,
 * ContentActionMenu). AdaptiveSheet handles this automatically.
 */
export function useSheetTabBarHold(): { hold: () => void; release: () => void } {
  const hideTabBar = useUIStore((s) => s.hideTabBar);
  const showTabBar = useUIStore((s) => s.showTabBar);
  return {
    hold: useCallback(() => hideTabBar(), [hideTabBar]),
    release: useCallback(() => showTabBar(), [showTabBar]),
  };
}
